import React from 'react';

import { Responsive } from 'app/shared/components/atoms';
import { Box } from 'app/shared/components/atoms';
import { ActionButton } from 'app/shared/components/molecules';
import { useEventAndAttendeeStatusMessaging } from 'app/fan/utils';
import { useEventPageContext } from 'app/fan/context/EventPage';
import { EventPageTemplate } from 'app/fan/components/templates';
import { ApplyFlowCheckoutWidget } from 'app/fan/components/pages/Event/components';
import {
  useApplyFlowPage,
  useTicketsUnavailablePage,
} from 'app/fan/components/pages/Event/eventUtils';

export const ApplyFlowTicketsUnavailableEventPage = () => {
  const { event, eventAttendee } = useEventPageContext();
  const attendeeState = eventAttendee?.currentState;
  const { numberOfTickets, setNumberOfTickets } = useApplyFlowPage();
  const { statusMessage } = useEventAndAttendeeStatusMessaging({
    event,
    attendeeState,
  });
  const { isOutOfStock, ticketSaleStatus, pageQaid } =
    useTicketsUnavailablePage(event);

  // We will never run into this scenario, but include this code so that
  // Typescript knows to expect this to be present
  if (!event) {
    return null;
  }

  const checkoutWidgetProps = {
    event,
    numberOfTickets,
    setNumberOfTickets,
    primaryCtaText: statusMessage,
    primaryCtaDataQaid: `${pageQaid}-button`,
    isPrimaryCtaFullWidth: true,
    isPrimaryCtaDisabled: true,
  };

  return (
    <EventPageTemplate
      data-qaid={pageQaid}
      event={event}
      attendeeState={attendeeState}
      isOutOfStock={isOutOfStock}
      ticketSaleStatus={ticketSaleStatus}
      secondColumn={<ApplyFlowCheckoutWidget {...checkoutWidgetProps} />}
    >
      <Box data-qaid="event-page-first-column-children">
        <Responsive hideUp="smallDesktop">
          <Box pt={8} pb={4} px={6}>
            <ActionButton
              disabled
              fullWidth
              variant="primary"
              data-qaid={`${pageQaid}-button`}
            >
              {statusMessage}
            </ActionButton>
          </Box>
        </Responsive>
      </Box>
    </EventPageTemplate>
  );
};
